import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372e6a8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'slaComment')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.row.slaComment)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: _normalizeClass(_ctx.row.slaComment === 'Опоздание' ? 'red' : 'green')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.row.slaComment), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, " - "))
      ], 64))
    : (_ctx.column.key === 'expectedDate')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(_ctx.row.expectedDate)), 1)
        ], 64))
      : (_ctx.column.key === 'date')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(_ctx.row.date)), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
          ], 64))
}